import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#FF6B35', // Orange accent color from mobile app
            light: '#FF8A5B',
            dark: '#E55A2B',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#2C3E50', // Dark blue-gray from mobile app
            light: '#34495E',
            dark: '#1A252F',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#2C3E50', // Main background color
            paper: '#34495E', // Card backgrounds
        },
        text: {
            primary: '#FFFFFF',
            secondary: 'rgba(255, 255, 255, 0.7)',
        },
        success: {
            main: '#2ECC71', // Green for ordered status
        },
        info: {
            main: '#3498DB', // Blue for quoted status
        },
        warning: {
            main: '#FF6B35', // Orange for waiting status
        },
        error: {
            main: '#E74C3C', // Red for cancelled status
        },
        grey: {
            50: '#FAFAFA',
            100: '#F5F5F5',
            200: '#EEEEEE',
            300: '#E0E0E0',
            400: '#BDBDBD',
            500: '#9E9E9E',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
        },
    },
    typography: {
        fontFamily: 'Ubuntu, Roboto, sans-serif',
        h1: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 700,
        },
        h2: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 700,
        },
        h3: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 700,
        },
        h4: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 700,
        },
        h5: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 600,
        },
        h6: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 600,
        },
        body1: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 400,
        },
        body2: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 400,
        },
        button: {
            fontFamily: 'Ubuntu, Roboto, sans-serif',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
    },
    shape: {
        borderRadius: 12, // Consistent with mobile app rounded corners
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#34495E',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    textTransform: 'uppercase',
                    fontWeight: 700,
                    letterSpacing: '0.5px',
                    boxShadow: '0 2px 8px rgba(255, 107, 53, 0.3)',
                    '&:hover': {
                        boxShadow: '0 4px 16px rgba(255, 107, 53, 0.4)',
                    },
                },
                contained: {
                    backgroundColor: '#FF6B35',
                    '&:hover': {
                        backgroundColor: '#E55A2B',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#2C3E50',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#2C3E50',
                    borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'rgba(255, 107, 53, 0.1)',
                    },
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(255, 107, 53, 0.2)',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 107, 53, 0.3)',
                        },
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: 12,
                        '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#FF6B35',
                        },
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: 12,
                },
            },
        },
    },
});

export default theme;
